
import _ from "@/boot/lodash";
import Vue, { RenderContext } from "vue";
export default Vue.extend({
  functional: true,
  render(h, context: RenderContext) {
    const scopedSlots = ["ticket", "filters", "table"];
    const slots = _.keyBy(context.children, "data.slot") as object;
    return h(
      "div",
      {
        class: ["ticket-table-layout", context.data.staticClass]
      },
      _.map(
        _.filter(scopedSlots, key => slots[key]),
        (key: string) => {
          const slot = slots[key];
          const slotClass = `layout-slot-${key.toLowerCase()}`;
          return h(
            "div",
            {
              class: slotClass,
              attrs: _.pickBy(slot.data.attrs, (val, key) => {
                return key.startsWith("data-scroll-");
              })
            },
            [
              h(
                "div",
                {
                  class: _.compact([
                    `${slotClass}-padding`,
                    slot.data.staticClass
                  ])
                },
                slot.children
              )
            ]
          );
        }
      )
    );
  }
});
